<template>
  <div :class="{
    'box box-website builder-container-list-websites_card-box-websites': isCardView || isMainCardView,
    'builder-container-list-websites_card-list-website': isListView
  }">
    <template v-if="isListView">
      <div v-if="selectWebsites" class="box-all-checked">
        <div class="form-check pl-0 pr-2">
          <input v-if="selectWebsites.type === 'all'" :checked="selectWebsites.type === 'all'" type="checkbox"
            @click.prevent="checkedSelectAll(config.id)">
          <input v-show="selectWebsites.type !== 'all'" :id="`selected-user-${config.id}`"
            v-model="selectWebsites.selectedWebsites" :value="config.id" type="checkbox" @change="changeUnitary()">
        </div>
      </div>
      <div
        :style="`background-image: url('${siteBackgroundImage}');`"
        class="card-list-image-container">
        <div v-if="pageHome && pageHome.url && website_type === 'websites' && !isStaticImport" class="card-list-image-upload-overlay">
          <router-link v-if="!pageHome.is_turbo" :to="{ name: 'editor', params: { page_id: pageHome.encrypted_id } }"
            class="btn-edit-website" target="_blank">{{ $t('ct-card-site-edit') }}
          </router-link>
        </div>
      </div>
      <website-info :config="config" :is-unpublish="isUnpublish" :website_type="website_type"
        class="card-list-info-container" />
      <div class="card-list-divisor" />
      <div class="box-visitors-count box-visitors-count--column">
        <template v-if="!isStaticImport">
          <builderall-loader :loading="loadingViews" class="box-visitors-loader">
            <span class="box-visitors-value">
              {{ formattedTotalViews }}
            </span>
          </builderall-loader>
          <span class="box-visitors-title">
            {{ $t('ct-visitors') }}
          </span>
        </template>
      </div>
      <div class="card-list-divisor" />
      <div v-if="isUnpublish" class="box-badge unpublished ba-mg-l-2 ba-mg-r-2">{{ $t('ct-unpublished') }}</div>
      <div v-else class="box-badge published ba-mg-l-2 ba-mg-r-2">{{ $t('ct-published') }}</div>
      <div v-if="isStaticImport" class="box-badge imported ba-mg-l-2 ba-mg-r-2">{{ $t('ct-imported') }}</div>
      <div class="card-list-divisor" />
      <website-actions
        :class="{ 'box-options': isCardView || isMainCardView, 'card-list-options': isListView }"
        :config="config"
        :page-home="pageHome"
        :website_type="website_type"
        :show="actionShow"
        @duplicate="duplicate"
        @change-html="changeHtml"
        @publish="publish"
        @transfer="transfer"
        @unpublish="unpublish"
        @uploadImagePage="uploadImagePage"
      />
    </template>

    <template v-else>
      <div class="box-body">
        <div class="box-actions">
          <div v-if="selectWebsites" class="box-all-checked pl-0 pr-2">
            <input v-show="selectWebsites.type === 'all'" :checked="selectWebsites.type === 'all'" type="checkbox"
              @click.prevent="checkedSelectAll(config.id)">
            <input v-show="selectWebsites.type !== 'all'" :id="`selected-user-${config.id}`"
              v-model="selectWebsites.selectedWebsites" :value="config.id" type="checkbox" @change="changeUnitary()">
          </div>
          <!-- <div v-if="isUnpublish && !isMirror" class="box-badge-unpublish">{{ $t('ct-unpublished') }}</div> -->
          <div v-if="isUnpublish && !isMirror" class="box-badge unpublished">{{ $t('ct-unpublished') }}</div>
          <div v-if="!isMirror && isStaticImport" class="box-badge imported">{{ $t('ct-imported') }}</div>
          <span class="spacer"></span>
          <!-- favorite toggle -->
          <svg role="button" class="favorites-toggle" @click.prevent="updateFavorite" xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
            <path d="M8 0.5C8.33204 0.5 8.63305 0.714569 8.74316 1.03809L10.0156 4.77637L10.1309 5.11523H14.7139C15.0481 5.11523 15.3502 5.33087 15.459 5.65625C15.5681 5.98374 15.4559 6.34452 15.1865 6.55078L11.7646 9.1709L11.4883 9.38281L11.5918 9.71582L12.75 13.4609V13.4619C12.853 13.7944 12.731 14.1541 12.4521 14.3535C12.316 14.4507 12.1572 14.499 12 14.499C11.8348 14.499 11.6697 14.4464 11.5322 14.3418L11.5312 14.3408L8.30176 11.9004L8 11.6729L7.69824 11.9004L4.46875 14.3408C4.19539 14.5476 3.82406 14.5532 3.54688 14.3555H3.54785C3.26949 14.1564 3.14679 13.7949 3.25 13.4619V13.4609L4.4082 9.71777L4.51172 9.38574L4.23535 9.17383L0.813477 6.55078L0.719727 6.46582C0.519477 6.25456 0.446032 5.94512 0.541016 5.65918C0.651316 5.33058 0.953458 5.11523 1.28613 5.11523H5.86914L5.98438 4.77637L7.25684 1.03809C7.36695 0.714567 7.66796 0.5 8 0.5Z"
              :fill="config.is_favorite ? '#3099FF' : 'white'" stroke="#B4C4D7"/>
          </svg>
        </div>
        <div
          :style="`background-image: url('${siteBackgroundImage}');`"
          class="box-image-container">
          <div v-if="pageHome && pageHome.url && website_type === 'websites' && !isStaticImport" class="box-upload-overlay">
            <router-link v-if="!pageHome.is_turbo" :to="{ name: 'editor', params: { page_id: pageHome.encrypted_id } }"
              class="btn-edit-website" target="_blank">{{ $t('ct-card-site-edit') }}
            </router-link>
          </div>
        </div>
      </div>
      <div v-if="config" class="box-footer">
        <website-info :config="config" :is-unpublish="isUnpublish" :website_type="website_type" class="box-info" />
        <div class="box-footer-info-row">
          <div class="box-visitors-count">
            <template v-if="!isStaticImport">
              <builderall-loader :loading="loadingViews" class="box-visitors-loader">
                <span class="box-visitors-value">
                  {{ formattedTotalViews }}
                </span>
              </builderall-loader>
              <span class="box-visitors-title">
                {{ $t('ct-visitors') }}
              </span>
            </template>
          </div>
          <website-actions
            :class="{ 'box-options': isCardView || isMainCardView, 'card-list-options': isListView }"
            :config="config"
            :page-home="pageHome"
            :website_type="website_type"
            :show="actionShow"
            @duplicate="duplicate"
            @change-html="changeHtml"
            @publish="publish"
            @transfer="transfer"
            @unpublish="unpublish"
            @uploadImagePage="uploadImagePage" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { duplicateWebsite, updateStatus, updateFavorite, getWebsiteTotalViews, getCachedWebsiteTotalViews } from './../../../../js/services/editor/website';
import WebsiteActions from "./websites/WebsiteActions.vue";
import WebsiteInfo from "./websites/WebsiteInfo.vue";

export default {
  name: 'SiteCardComponent',
  components: {
    WebsiteInfo,
    WebsiteActions,
  },

  props: ['website_type', 'config', 'categories', 'type_view', 'selectWebsites'],

  data() {
    return {
      pageHome: { configuration: {} },
      totalViews: null,
      loadingViews: false,
      currentViewsRequestId: null,
    };
  },

  computed: {
    formattedTotalViews() {
      if (this.totalViews === null) return '0';

      return this.totalViews.toLocaleString();
    },

    isUnpublish() {
      return this.config.status !== 'active';
    },

    isMirror() {
      return this.website_type === 'mirror';
    },

    isListView() {
      return this.type_view === 'list';
    },

    isCardView() {
      return this.type_view === 'card';
    },

    isMainCardView() {
      return this.type_view === 'maincard';
    },

    isStaticImport() {
      return this.config && this.config.type == 'static_import';
    },

    siteBackgroundImage() {
      if (this.pageHome.configuration && this.pageHome.configuration.og_image) {
        return this.pageHome.configuration.og_image;
      }
      if (this.config.thumbnail_portrait) {
        return this.config.thumbnail_portrait;
      }
      if (this.config.thumbnail) {
        return this.config.thumbnail;
      }
      return '/static/images/cheetah-og.png';
    },

    actionShow() {
      if (this.isStaticImport)
      {
        return ['settings', 'eye', 'publish', 'edit'];
      }

      return ['settings', 'website-manager', 'supercheckout', 'eye', 'publish', 'edit'];
    },
  },

  watch: {
    config: function () {
      this.homePage();
    },

    'config.encrypted_id': {
      immediate: true,
      handler(encryptedId) {
        if (encryptedId && !this.isStaticImport) {
          this.loadTotalViews(encryptedId);
        }
      },
    },
  },

  methods: {
    ...mapGetters({ getUser: 'user' }),
    updateWebsites() {
      this.$emit('updateWebsites');
    },

    checkedSelectAll(website_id) {
      this.$emit('checkedSelectAll', website_id);
    },

    changeUnitary() {
      this.$emit('changeUnitary');
    },

    uploadImagePage(page) {
      this.$emit('uploadImagePage', page);
    },

    unpublish(status = 'inactive') {
      let data = {
        encrypted_id: this.config.encrypted_id,
        status: status
      };

      this.updateStatus(data);
    },

    updateStatus(data) {
      this.$loading.show();

      updateStatus(data)
        .then(() => {
          this.$loading.hide();
          this.updateWebsites();
        })
        .catch(() => {
          this.$loading.hide();
          this.$snotify.error(
            'Something happened when trying to unpublish or publish your site, check the settings'
          );
        });
    },

    updateFavorite() {
      let data = {
        encrypted_id: this.config.encrypted_id,
        is_favorite: this.config.is_favorite ? '0' : '1'
      };

      this.$loading.show();

      updateFavorite(data)
        .then(() => {
          this.$loading.hide();
          this.$emit('updateFavorite', {
            site_id: this.config.id,
            is_favorite: !this.config.is_favorite
          })
        })
        .catch(() => {
          this.$loading.hide();
          this.$snotify.error(
            'Something happened when trying to favorite your site, check the settings'
          );
        });
    },

    duplicate() {
      this.$loading.show();

      duplicateWebsite(this.config)
        .then(data => {
          if (data.data.success === false)
            this.$snotify.warning(this.$t(data.data.error));

          this.updateWebsites();
          this.$snotify.success(this.$t('ct-duplicate-success'));
        })
        .catch(error => {
          if (error.response) {
            // Request made and server responded
            if (error.response.status === 429) { // to many
              this.$snotify.error(this.$t('ct-too-many-attempts'));
            }
          }
        })
        .finally(() => this.$loading.hide());
    },

    transfer(show, config = '') {
      this.$emit('transfer', show, config);
    },

    publish(show) {
      this.$emit('publish', show, this.config);
    },

    changeHtml() {
      this.$root.$emit('open-ai-html-upload', this.config);
    },

    getPageHome(data) {
      return data.find(page => !!page.initial);
    },

    homePage() {
      if (this.config.layouts && this.config.layouts[0] && this.config.layouts[0].pages && this.config.layouts[0].pages.length > 0) {
        let home = this.getPageHome(this.config.layouts[0].pages);
        this.pageHome = home || this.config.layouts[0].pages[0];
      }
    },

    loadTotalViews(encryptedId) {
      this.currentViewsRequestId = encryptedId;

      const cachedTotal = getCachedWebsiteTotalViews(encryptedId);

      if (cachedTotal !== null) {
        this.totalViews = cachedTotal;
        this.loadingViews = false;
        return;
      }

      this.totalViews = null;
      this.loadingViews = true;

      getWebsiteTotalViews(encryptedId)
        .then((total) => {
          if (this.currentViewsRequestId !== encryptedId) return;

          this.totalViews = total;
        })
        .catch(() => {
          if (this.currentViewsRequestId !== encryptedId) return;

          this.totalViews = 0;
        })
        .finally(() => {
          if (this.currentViewsRequestId !== encryptedId) return;

          this.loadingViews = false;
        });
    },
  },
  mounted() {
    this.homePage();
  }
};
</script>

<style lang="scss" scoped>
.box-footer-info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;

  /deep/ .box-options {
    width: auto;
    flex-shrink: 0;
  }
}

.box-visitors-count {
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 2px 6px;
  min-width: 0;

  .box-visitors-loader {
    min-height: 22px;
    display: inline-flex;
    align-items: baseline;
  }

  .box-visitors-value {
    font-size: 18px;
    font-weight: 500;
    color: #3D3D3D;
    white-space: nowrap;
  }

  .box-visitors-title {
    font-size: 12px;
    font-weight: 500;
    color: #8D9EB5;
    white-space: nowrap;
  }

  &--column {
    flex: none;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    gap: 2px;
    min-width: 72px;
    text-align: center;

    .box-visitors-loader {
      align-items: center;
      justify-content: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/layout/site/SiteCard.vue